import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import GlobalStyles from './GlobalStyles';
import HomePage from './pages/HomePage';
import { Helmet } from 'react-helmet';
import favicon from './assets/logo.ico';

function App() {
  return (
    <Router>
      <Helmet>
        <link rel="icon" href={favicon} type="image/png" />
        <title>AdChain</title>
      </Helmet>
      <GlobalStyles />
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
